import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/_services/data.service';

@Component({
  selector: 'app-building-list',
  templateUrl: './building-list.component.html',
  styleUrls: ['./building-list.component.scss']
})
export class BuildingListComponent implements OnInit {
  projUid: any;
  buildList: any;
  compositeDesign: any = false;
  unika: any = false;
  currentBuildingId: string;
  selectedTitle: string;
  current: string;
  @Input() public projId: string;
  @Input() public routeParams;
  @Output() public showBuildingSubMenu = new EventEmitter();
  @Output() public currentBuilding1 = new EventEmitter();

  zones: { title: string; list: any; }[];
  urlSwitcher: string = '';
  currentLanguage: string = 'he';


  constructor(
    public dataService: DataService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.projUid = this.route.snapshot.params.idp
    this.currentBuildingId = this.route.snapshot.params.buid;
  }

  ngOnInit(): void {
    this.compositeDesign = this.dataService.wichDesign().compositeDesign;
    this.unika = this.dataService.wichDesign().unika;
    this.urlSwitcher = this.dataService.wichDesign().urlSwitcher;
    if (this.route.snapshot.queryParams.lang) {
      this.currentLanguage = this.route.snapshot.queryParams.lang;
    }
    this.dataService.getItemsByProjId(this.projId).subscribe(buildList => {
      this.buildList = buildList;
      console.log("buldList", buildList);

      this.buildList.forEach(building => {
        // if(building.withBuilding === false){
        //   let index = this.buildList.indexOf(building);
        //   this.buildList.splice(index, 1);
        // }
        if (building.uid === this.currentBuildingId) {
          this.current = building.uid;
          this.selectedTitle = building.name;
          this.currentBuilding1.emit(building);
          // setTimeout(function () {
          //   if (building.startScene) {

          //     let domStartSceneButton: any = document.getElementsByClassName(building.startScene)[0];
          //     if (!domStartSceneButton.classList.contains('current')) {
          //       domStartSceneButton.click();
          //     }

          //   }
          // }, 2000);
        }
      });
      this.addZoneTitles(buildList)
    })

    // this.route.url.subscribe(segment => {
    //   this.ifCompositeDesign(segment);
    // })


  }
  // ifCompositeDesign(segment) {
  //   if(segment.length > 3){ 
  //     for(let i = 0; segment.length > i; i++) {
  //       if (segment[i].path === 'n') {
  //         this.compositeDesign = true;
  //       } else if (segment[i].path === 'u') {
  //         this.compositeDesign = true;
  //         this.unika = true;
  //       }
  //     }
  //   }
  // }


  addZoneTitles(buildings) {
    const areasWithBuildings = buildings.reduce((acc, building) => {
      if (!acc[building.buildingZone]) {
        acc[building.buildingZone] = [];
      }
      acc[building.buildingZone].push(building);
      return acc;
    }, {});

    const areasWithBuildingsArray = Object.keys(areasWithBuildings).map(area => ({
      title: area,
      list: areasWithBuildings[area]
    }))

    this.zones = areasWithBuildingsArray;
  }

  closeMenu() {
    this.showBuildingSubMenu.emit('false');
  }


  viewBuildDetailsMenu(building) {
    // setTimeout(function () {
    //   if (building.startScene) {
    //     let domStartSceneButton: any = document.getElementsByClassName(building.startScene)[0];
    //     if (!domStartSceneButton.classList.contains('current')) {
    //       domStartSceneButton.click();
    //     }

    //   }
    // }, 2000);
    // if (building.startScene) {
    //   let domStartSceneButton: any = document.getElementsByClassName(building.startScene)[0];
    //   domStartSceneButton.click();
    // }
    let isFlatProppertiesOpened = document.getElementsByClassName('move-canvas');
    if (isFlatProppertiesOpened.length > 0) {
      isFlatProppertiesOpened[0].classList.remove('move-canvas');
      this.dataService.savecurrentFlatsPanelOnClickShow(false);
    }

    this.showBuildingSubMenu.emit('false');
    this.currentBuilding1.emit(building);
    if (this.routeParams) {
      this.current = building.uid;
      this.selectedTitle = building.name;
      this.currentBuilding1.emit(building);

      let segment;
      if (this.route.snapshot.firstChild) {
        segment = this.route.snapshot.firstChild.url;
      } else {
        segment = this.route.snapshot.url;
      }
      if (this.routeParams.seheluser) {
        this.router.navigate([this.urlSwitcher + this.routeParams.id + '/' + this.routeParams.idp + '/seheluser/' + this.routeParams.seheluser + '/building/' + building.uid]);
      } else {
        this.router.navigate([this.urlSwitcher + this.routeParams.id + '/' + this.routeParams.idp + '/building/' + building.uid], {
          queryParams: { lang: this.currentLanguage },
          queryParamsHandling: 'merge' // Merges with any existing query params in the URL
        });

      }
    }
    this.dataService.saveCurBuilding(building);
    this.dataService.currentBuild(building);
    // setTimeout(function () {
    //   if(document.getElementsByClassName('3d-flat-holder-project').length > 0) {
    //     let obj3d = document.getElementsByTagName('app-threejs')[0];
    //     let container = document.getElementsByClassName('3d-flat-holder-project')[0];
    //     container.prepend(obj3d);
    //   }
    // }, 100);
  }



}
